module.exports = __webpack_public_path__ + "img/publicarvagas.119b5fdd.png";